<template>
  <div>
    <div v-if="!example" class="loader"/>
    <div v-else>
      <div class="sentence">
        <span v-for="(w, k) in words" :key="k" @mouseenter="highlightColls(k+1)" @mouseleave="highlightColls(null)"
              :class="{'highlight': isWordHighlighted(k+1)}" class="word">{{w}} </span>
      </div>
      <div class="source">
        <a :href="this.example.ref.split('@')[0]" target="_blank">
          {{ this.example.ref.match(/^https?\:\/\/([^\/?#:]+)(?:[\/?#:]|$)/i)[1] }}
        </a> /
        {{ this.example.date.split("-")[0] }} /
        يمكنك إظهار
        <a :href="this.parse_tree_url" target="_blank">
          شجرة التحليل
        </a>
      </div>
      <h2> المتواردات اللفظية </h2>
      <div v-for="g of patternGroups" :key="g.pattern" :class="g.css_label">
        <div class="list-title">
          {{g.pattern}}
        </div>
        <div>
        <collocation v-for="c of g.collocations" :key="c.idx.join(' ')"
          :lempos-string="c.lempos.join(' ')" :pattern="c.pattern" class="collocation"
          :class="{'highlight': isCollHighlighted(c)}"
          @mouseenter.native="highlightWords(c)" @mouseleave.native="highlightWords(null)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api, baseUrl } from '../mixins/api.js'
import Collocation from './Collocation.vue'
import { PATTERN_CLASSES } from '../lib/patters'

export default {
  name: 'ExampleDetails',
  mixins: [api],
  components: { Collocation },
  props: {
    example_ref: String
  },
  data: function () {
    return { selectedCollocation: null, selectedWordIdx: null }
  },
  created: function () {
    this.fetchData()
  },
  watch: {
    example_ref: function () {
      this.fetchData()
    }
  },
  computed: {
    example () {
      return this.$store.state.examples[this.example_ref]
    },
    patternGroups () {
      var groups = Object.entries(PATTERN_CLASSES).map(([p, label], i) => ({
        pattern: p,
        css_label: label,
        collocations: this.example.collocations.filter(c => c.pattern === p)
      }))
      return groups.filter(g => (g.collocations.length > 0))
    },
    words () { return this.example.words },
    parse_tree_url () {
      return baseUrl + 'get_parse_tree?ref=' + encodeURIComponent(this.example_ref)
    }
  },
  methods: {
    highlightColls (wordIdx) {
      this.selectedWordIdx = wordIdx
      // console.log('Selected index ' + this.selectedWordIdx + ' highlighting colls ' +
      //             this.example.collocations.filter(c => this.isCollHighlighted(c)).map(c => c.lempos_string))
    },
    isCollHighlighted (c) {
      if (this.selectedWordIdx != null) {
        return c.idx.includes(this.selectedWordIdx)
      }
      return false
    },
    highlightWords (c) {
      this.selectedCollocation = c
    },
    isWordHighlighted (wordIdx) {
      if (this.selectedCollocation != null) {
        return this.selectedCollocation.idx.includes(wordIdx)
      }
      return false
    },
    fetchData () {
      this.$store.dispatch('loadExample', { ref: this.example_ref })
    }
  }
}
</script>

<style scoped>
  .sentence {
    font-size: 120%;
    line-height: 150%
  }
  h2 {
    font-size: 18px;
    font-weight: bold;
    margin-top: 20px
  }
  .source {
    margin-top: 5px;
    font-size: 80%;
    color: grey
  }
  .list-title {
    clear: both;
    width: 100%;
    padding: 10px 5px 0px 5px;
    font-size: 80%;
    /* border-top: 1px solid lightgrey; */
    color: gray;
  }
  .collocation {
    background-color: var(--bg-color);
    /* background-image: repeating-linear-gradient(-45deg,
      transparent,
      transparent 5px,
      white 5px,
      white 10px) */
  }
  .collocation.highlight {
    background-color: var(--bg-color-2) !important;
  }
  .word.highlight {
    background-color: rgb(220, 220, 220)
  }
</style>
